import genericModalStyles from "helpers/genericModalStyles";
import ModalContent from "components/ModalContent";
import LinkButtonGroup from "components/LinkButtonGroup";
import LinkButton from "components/LinkButton";
import Modal from "components/Modal";
import React from "react";

const TeamNotFoundModal = ({ closeModal }) => (
  <Modal
    contentLabel="The team you selected could not be joined"
    customStyle={genericModalStyles}
    isOpen
    onRequestClose={closeModal}
    shouldCloseOnOverlayClick
  >
    <ModalContent
      action={(
        <LinkButtonGroup>
          <LinkButton
            look="secondary-outline"
            onClick={closeModal}
          >
            Ok
          </LinkButton>
        </LinkButtonGroup>
      )}
      body={(
        <div>
          <p>
            We were unable to find the team you selected.
            <br />
            <br />
            Please try a different team or refresh this page.
            <br />
            <br />
          </p>
        </div>
      )}
      heading="The team you selected could not be joined"
    />
  </Modal>
);

export default TeamNotFoundModal;
